import React, { useState } from "react";
import { RoundedRedBtn } from "../../components/button.jsx/Btn";
import { DeleteItem, SuccessfulDelete } from "../../components/modal";
import verifyImg from "../../assets/confirm.png";
import DeleteImg from "../../assets/delete.png";
import caristasImage from "../../assets/Ellipse 38 (1).png";

const InstitutionPage = () => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const [openSuccessfulDeleteModal, setOpenSuccessfulDeleteModal] =
    useState(false);

  const handleDelete = () => {
    setOpenDeleteModal(true);
  };

  const cancelModal = () => setOpenDeleteModal(false);

  const confirmDelete = () => {
    setOpenDeleteModal(false);
    setOpenSuccessfulDeleteModal(true);
  };

  const closeSuccessfulDeleteModal = () => {
    setOpenSuccessfulDeleteModal(false);
  };

  const user = {
    name: "Caritas Rising Academy",
    email: "cracademy@gmail.com",
    profilePicture: caristasImage, // Add the correct path to the profile picture
    Tutors: 20,
    Lessons: 5,
    Students: 10,
    Student: 10,
    lessons: [
      {
        subject: "Mathematics",
        progress: 75,
        totalTopics: 7,
        status: "In Progress",
      },
      {
        subject: "Mathematics",
        progress: 75,
        totalTopics: 7,
        status: "Completed",
      },
      {
        subject: "Mathematics",
        progress: 75,
        totalTopics: 7,
        status: "Yet to Start",
      },
      {
        subject: "Mathematics",
        progress: 75,
        totalTopics: 7,
        status: "Completed",
      },
      {
        subject: "Mathematics",
        progress: 75,
        totalTopics: 7,
        status: "Completed",
      },
    ],
  };

  return (
    <div>
      <div className=" bg-white m-3">
        <h1 className="font-[700] font-satoshi text-[#202020] text-[20px] leading-[30px] mb-6 ">
          Institution Details
        </h1>
        <div className=" rounded-lg p-8 h-screen bg-white shadow-lg">
          <div className=" mb-6 bg-[#DDD3FF] p-4 rounded-md w-full h-[156px]">
            {/* Add Parent Button */}
            <div className="float-right">
              <RoundedRedBtn onClick={handleDelete}>
                Delete Institution
              </RoundedRedBtn>
            </div>

            <DeleteItem
              isOpen={openDeleteModal}
              onClose={cancelModal}
            >
              <div>
                <img
                  className=" w-10 h-10
                "
                  src={DeleteImg}
                  alt="verify del"
                />

                <h1 className="text-xl text-[#400167] font-bold">
                  Delete Item?
                </h1>
                <p className="text-xs my-2">
                  Are you sure you want to delete ‘Item’? Action can not be
                  reversed.
                </p>
              </div>
              <div className="flex items-center text-xs gap-4 mt-2">
                <button
                  className="bg-[#5002D0] text-white  font-medium py-2 px-4 rounded-[10px] w-[102px]"
                  onClick={confirmDelete}
                >
                  Continue
                </button>
                <button
                  className=" font-medium py-2 px-4 rounded-[10px] w-[87px] text-[#E34033]"
                  style={{ backgroundColor: "rgba(227, 64, 51, 0.2)" }}
                  onClick={cancelModal}
                >
                  Cancel
                </button>
              </div>
            </DeleteItem>

            <SuccessfulDelete
              isOpen={openSuccessfulDeleteModal}
              onClose={closeSuccessfulDeleteModal}
            >
              <div>
                <img
                  src={verifyImg}
                  alt=" verify delete"
                  className=" w-28"
                />
                <h2 className="text-[#400167] text-xl font-bold mb-2">
                  Item Deleted
                </h2>
                <p className="text-[#74777B] text-xs ">
                  `Item name` has been deleted successfully
                </p>
              </div>
            </SuccessfulDelete>

            {/* User Details */}
            <div className="flex mt-5">
              <div>
                <img
                  src={user.profilePicture}
                  alt="Profile"
                  className="w-[100px] h-[100px] rounded-full mr-5"
                />
              </div>
              <div>
                <div className="flex items-start gap-32">
                  <div>
                    <h2 className="text-[24px] rounded-lg text-[#620899] font-semibold leading-[]">
                      {user.name}
                    </h2>
                    <p className="text-black">{user.email}</p>
                  </div>
                </div>
                <p className="text-[12px] font-[300] w-[413px] font-satoshi leading-[19.62px] mt-3 text-black">
                  Lorem ipsum dolor sit amet consectetur. Non turpis risus
                  rhoncus vulputate. Lorem ipsum dolor sit amet consectetur. Non
                  turpis risus rhoncus vulputate.
                </p>
              </div>
            </div>
          </div>
          {/* User Stats */}
          <h3 className="text-[20px] mt-4 text-[#400167] font-semibold mb-4 leading-[23px]">
            Institution Overview
          </h3>

          {/* User Stats */}
          <div className="flex  items-center gap-10 mb-6">
            <div
              className="bg-white p-4 rounded-lg shadow-md w-[181px] flex items-center gap-3 font-satoshi"
              style={{ border: "1px solid rgba(4, 167, 167, 0.5)" }}
            >
              <p className="text-center text-[32px] font-[500]">
                {user.Tutors}
              </p>
              <p className="text-center text-gray-500 text-[14px] font-[500] mt-3">
                Tutors
              </p>
            </div>
            <div
              className="bg-white p-4 rounded-lg shadow-md w-[181px] flex items-center gap-3 font-satoshi"
              style={{ border: "1px solid rgba(241, 130, 217, 0.5)" }}
            >
              <p className="text-center text-[32px] font-[500]">
                {user.Lessons}
              </p>
              <p className="text-center text-gray-500 text-[14px] font-[500] mt-3">
                Lessons
              </p>
            </div>
            <div
              className="bg-white p-4 rounded-lg shadow-md w-[181px] flex items-center gap-3 font-satoshi"
              style={{ border: "1px solid rgba(2, 105, 208, 0.5)" }}
            >
              <p className="text-center text-[32px] font-[500]">
                {user.Students}
              </p>
              <p className="text-center text-gray-500 text-[14px] font-[500] mt-3">
                Students
              </p>
            </div>
            <div
              className="bg-white p-4 rounded-lg shadow-md w-[181px] flex items-center gap-3 font-satoshi"
              style={{ border: "1px solid rgba(0, 197, 67, 0.5)" }}
            >
              <p className="text-center text-[32px] font-[500]">
                {user.Student}
              </p>
              <p className="text-center text-gray-500 text-[14px] font-[500] mt-3">
                Students
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstitutionPage;
